import React from 'react';

const MarqiLogo = ({ size = 'default', variant = 'default' }) => {
  const sizeClasses = {
    small: 'text-xl',
    default: 'text-2xl', 
    large: 'text-4xl',
    xl: 'text-6xl'
  };

  const MarqiLetterLogo = ({ className }) => (
    <div className={`font-bold tracking-tight ${className}`}>
      <span className="relative">
        <span className="text-white">MARQ</span>
        <span className="relative">
          <span className="text-white">I</span>
          {/* Stylized dot on the I */}
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2">
            <div className="w-2 h-2 bg-[var(--accent-primary)] rounded-full animate-pulse"></div>
            {/* Subtle glow effect */}
            <div className="absolute inset-0 w-2 h-2 bg-[var(--accent-primary)] rounded-full blur-sm opacity-60"></div>
          </div>
        </span>
      </span>
    </div>
  );

  if (variant === 'icon-only') {
    return (
      <div className={`relative ${sizeClasses[size]}`}>
        <div className="w-8 h-8 bg-[var(--bg-tertiary)] rounded-lg flex items-center justify-center border border-[var(--border-subtle)]">
          <span className="font-bold text-[var(--accent-primary)] text-sm">M</span>
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-[var(--accent-primary)] rounded-full animate-pulse"></div>
        </div>
      </div>
    );
  }

  if (variant === 'stacked') {
    return (
      <div className="text-center">
        <MarqiLetterLogo className={sizeClasses[size]} />
        <div className="text-xs text-[var(--accent-primary)] mt-2 tracking-widest uppercase font-semibold">
          AI-Powered Growth
        </div>
      </div>
    );
  }

  return (
    <div className="text-center">
      <MarqiLetterLogo className={sizeClasses[size]} />
    </div>
  );
};

export default MarqiLogo;